<template>
  <div class="accessGuide">
    <p><el-link type="primary" href="https://iq.feishu.cn/docx/XTvIdwykhoGsnkx9ez7cSn8Fnfb" target="_blank">API Integration Document</el-link></p>
    <p><el-link type="primary" href="https://iq.feishu.cn/docx/KrxddEueGoO4mGxGO7TclcGyn7f" target="_blank">Union-Ad Reporting API</el-link></p>
    <hr>
    <p>
      <span>Post URL: </span>
      <el-link type="primary" href="https://ssp.iqiyi.net/openapi/report" target="_blank">https://ssp.iqiyi.net/openapi/report</el-link>
    </p>
    <p>
      <span>Access Token: </span>
      <el-input :value="accessToken" disabled></el-input>
    </p>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      accessToken: null
    }
  },
  mounted() {
    const {accessToken} = this.$store.state.accountInfo
    this.accessToken = accessToken
  }
}
</script>
<style scoped>
p {
  font-size: 14px;
}

hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  transform: scaleY(0.5);
}

.accessGuide p {
  margin: 10px 0;
}

.el-input {
  width: 300px;
}
</style>